import { lazy } from "react";
import Loadable from "helpers/loadable";

export const Home = Loadable(lazy(() => import("./home")));
export const Login = Loadable(lazy(() => import("./login")));
export const Synchronize = Loadable(lazy(() => import("./sync")));
export const OnBoard = Loadable(lazy(() => import("./onBoard")));
export const ResetPassword = Loadable(lazy(() => import("./resetPassword")));

export const Notification = Loadable(lazy(() => import("./notification")));
export const Announcement = Loadable(lazy(() => import("./announcement")));
export const DetailAnnouncement = lazy(() => import("./announcement/detailAnnouncement"));
export const Tes = Loadable(lazy(() => import("./tes")));
export const DetailTes = Loadable(lazy(() => import("./tes/detailTes")));
export const PerformTes = Loadable(lazy(() => import("./tes/performTes")));
export const Profile = Loadable(lazy(() => import("./profile")));
export const InfoPersonal = lazy(() => import("./profile/infoPersonal"));
export const ProfilSekolah = Loadable(lazy(() => import("./profile/profilSekolah")));
